import { render, staticRenderFns } from "./ShowBanner.vue?vue&type=template&id=0313074c&scoped=true&"
import script from "./ShowBanner.vue?vue&type=script&lang=js&"
export * from "./ShowBanner.vue?vue&type=script&lang=js&"
import style0 from "./ShowBanner.vue?vue&type=style&index=0&id=0313074c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313074c",
  null
  
)

export default component.exports